export default "__VITE_ASSET__79ac6541__"